import { theme as a } from "../theme/index.js";
import { n as r } from "./emotion-styled.browser.esm.js";
const d = r.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding: 1rem;
  height: 100%;
  overflow-y: auto;
`, m = r.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`, l = r.div`
  text-align: center;
  font-size: 0.875rem;
  padding: 0.5rem 0.5rem 0;
  position: sticky;
  top: 0;
`, c = r.div`
  display: grid;
  ${({ messageAlign: e }) => e === "right" ? `
        grid-template-columns: auto max-content;
        .message-content {
        order: 1;
        }
        .avatar-wrapper {
          order: 2;
        }
        .message-actions {
          order: 3;
        }
        .empty-padding {
          order: 4;
        }
      ` : `
      grid-template-columns: max-content auto;
      .avatar-wrapper {
        order: 1;
      }
      .message-content {
        order: 2;
      }
      .empty-padding {
        order: 3;
      }
      .message-actions {
        order: 4;
      }
    `}
`, p = r.div`
  max-width: min(90%, 40rem);
  padding: 0.75rem 1rem;
  border-radius: 0.75rem;
  ${({ align: e, avatarAlign: t, backgroundColor: o, textColor: n }) => `
    margin-${e === "left" ? "right" : "left"}: auto;
    background-color: ${o || (e === "left" ? a.colors.gray[100] : a.colors.green[100])};
    color: ${n || "inherit"};
    border-${t}-${e}-radius: 0;
  `}
`, g = r.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: ${({ align: e }) => e === "top" ? "flex-start" : "flex-end"};
  ${({ messageAlign: e, isEmpty: t }) => t ? "" : e === "right" ? "margin-left: 0.5rem;" : " margin-right: 0.5rem"}
`, f = r.div`
  display: flex;
  justify-content: ${({ align: e }) => e === "left" ? "flex-start" : "flex-end"};
`;
export {
  g as A,
  d as C,
  l as G,
  m as M,
  c as a,
  p as b,
  f as c
};
